import Header from "./Header"
import FoodOptions from "./FoodOptions"
import DineOptions from "./DineOptions"
import Footer from "./Footer"


export default function Home(){
    return(
        <>
            <Header/>
            <FoodOptions/>
            <DineOptions/>
            <Footer/>
        </>
    )
}